import { createEntryPreviewStore } from '@/app/_components/entryPreview';

export interface CampaignPreview {
  campaignId: string;
  mainImageUrl: string;
  thumbnailSrc?: string;
  productName: string;
  institutionName: string;
  marketPrice: number;
}

const campaignPreviewStore = createEntryPreviewStore<CampaignPreview>();

export const rememberCampaignPreview = campaignPreviewStore.remember;
export const clearCampaignPreview = campaignPreviewStore.clear;
export const subscribeCampaignPreview = campaignPreviewStore.subscribe;
export const getCampaignPreviewSnapshot = campaignPreviewStore.getSnapshot;

export const matchCampaignPreview = (
  preview: CampaignPreview | null,
  campaignId?: string,
) => (preview && preview.campaignId === campaignId ? preview : null);
